<div class="card">
    <h2 class="section-title">{{ 'profileContact.contact' | translate }}</h2>
    <div class="contact-list">
        <div class="contact-item">
            <span class="contact-icon email-icon" *ngIf="email"><i class="bi bi-envelope"></i></span>
            <span class="contact-value">{{ email }}</span>
        </div>
        <div class="contact-item" *ngIf=" phoneNumber ">
            <span class="contact-icon phone-icon"><i class="bi bi-telephone"></i></span>
            <span class="contact-value">{{ phoneNumber }}</span>
        </div>
        <!-- CV Link -->
        <div class="contact-item" *ngIf="cvUrl">
            <span class="contact-icon web-icon"><i class="bi bi-globe"></i></span>
            <a [href]="getCvUrl()" target="_blank">
                <span class="contact-value">{{ name }}.CV</span>
            </a>
        </div>

        <!-- LinkedIn Link -->
        <div class="contact-item" *ngIf="linkedInLink">
            <span class="contact-icon web-icon"><i class="bi bi-linkedin"></i></span>
            <a [href]="linkedInUrl" target="_blank">
                <span class="contact-value">{{ linkedInLink }}</span>
            </a>
        </div>
    </div>
</div>